import { render, staticRenderFns } from "./Kohde.vue?vue&type=template&id=3f805d80&"
import script from "./Kohde.vue?vue&type=script&lang=js&"
export * from "./Kohde.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Kohde.vue"
export default component.exports